if (typeof debounce === 'undefined') {
  var debounce = function (fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  };
}
/**
 *  @class
 *  @function StickyHeader
 */
if (!customElements.get('sticky-header')) {
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      if (this.hasAttribute('data-disabled')) return;
      this.headerBounds = {};
      this.header = this.querySelector('theme-header');
      this.section = this.closest('.section-header-section');
      this.currentScrollTop = 0;
      this.ticking = false;
      this.onScrollHandler = this.onScroll.bind(this);
      this.measure = this.measure.bind(this);

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.measure();
      window.addEventListener('load', this.measure);
      window.addEventListener('resize', debounce(this.measure, 150));
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(this.measure);
      }
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.measure);
      window.removeEventListener('load', this.measure);
    }
    measure() {
      if (!this.header || !this.section) return;
      // Only measure while the header is in normal flow; a fixed/sticky header
      // would report viewport-relative coordinates and corrupt the bounds.
      if (this.section.classList.contains('section-header-section--is-sticky') && this.headerBounds.bottom) return;
      const rect = this.section.getBoundingClientRect();
      const top = rect.top + window.scrollY;
      // Use the visible header bar height, not theme-header.offsetHeight, which can be
      // inflated by off-canvas/hidden content and create a large dead zone.
      const bar = this.header.querySelector('.header--inner');
      const barHeight = bar ? bar.getBoundingClientRect().height : rect.height;
      this.headerBounds = { top: top, bottom: top + barHeight };
    }
    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        const scrollTop = window.scrollY;
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.hide();
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.show();
        } else if (scrollTop <= this.headerBounds.top) {
          this.reset();
        }
        this.currentScrollTop = scrollTop;
        this.ticking = false;
      });
    }

    hide() {
      this.section.classList.add(
        'section-header-section--is-hidden',
        'section-header-section--is-sticky'
      );
      this.header.classList.remove('is-sticky');
    }

    show() {
      this.section.classList.add('section-header-section--is-sticky', 'section-header-section--animate');
      this.section.classList.remove('section-header-section--is-hidden');
      this.header.classList.add('is-sticky');
    }

    reset() {
      this.section.classList.remove(
        'section-header-section--is-hidden',
        'section-header-section--is-sticky',
        'section-header-section--animate'
      );
      this.header.classList.remove('is-sticky');
    }
  }
  customElements.define('sticky-header', StickyHeader);
}
/**
 *  @class
 *  @function ThemeHeader
 */
if (!customElements.get('theme-header')) {
  class ThemeHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.header_section = document.querySelector('.section-header-section');
      this.menu = this.querySelector('#mobile-menu');
      this.toggle = document.querySelector('.mobile-toggle-wrapper');
      this.search_toggles = document.querySelectorAll('.thb-quick-search');
      this.search_drawer = document.getElementById('Search-Drawer');
      this.search_input = this.search_drawer ? this.search_drawer.querySelector('input[type="search"]') : null;
      const body = document.body;
      document.addEventListener('keyup', (e) => {
        if (e.code) {
          if (e.code.toUpperCase() === 'ESCAPE') {
            this.toggle.removeAttribute('open');
            this.toggle.classList.remove('active');
            document.body.classList.remove('overflow-hidden');
            this.closeAll();
          }
        }
      });

      // Search toggle
      this.search_toggles.forEach((item, i) => {
        item.addEventListener('click', (e) => {
          e.preventDefault();

          body.classList.add('open-cc', 'overflow-hidden');
          this.search_drawer.classList.toggle('active');
          setTimeout(() => {
            if (this.search_input) this.search_input.focus({ preventScroll: true });
          }, 100);
          dispatchCustomEvent('search:open');
          this.search_drawer.removeAttribute('inert');
        });
      });
      // Mobile menu toggles
      const toggleClass = this.toggle.classList;
      this.toggle.querySelector('.mobile-toggle').addEventListener('click', (e) => {
        if (toggleClass.contains('active')) {
          e.preventDefault();
          body.classList.remove('overflow-hidden');
          toggleClass.remove('active');
          this.closeAnimation(this.toggle);
          setTimeout(() => {
            this.closeAll();
          }, 250);
        } else {
          body.classList.add('overflow-hidden');
          setTimeout(() => {
            toggleClass.add('active');
          });
        }
        window.dispatchEvent(new Event('resize-select'));
      });

      // Mobile Menu offset + height — height only on resize/load, offset rAF-throttled
      this.setHeaderOffset();
      this.setHeaderHeight();
      this._rafScroll = false;
      this.onHeaderScroll = () => {
        if (this._rafScroll) return;
        this._rafScroll = true;
        requestAnimationFrame(() => {
          this.setHeaderOffset();
          this._rafScroll = false;
        });
      };
      window.addEventListener('scroll', this.onHeaderScroll, { passive: true });
      window.addEventListener('resize', debounce(() => { this.setHeaderOffset(); this.setHeaderHeight(); }, 100));

      if (document.querySelector('.header-announcement-bar')) {

        window.addEventListener('scroll', this.setAnnouncementHeight.bind(this), {
          passive: true
        });
        window.dispatchEvent(new Event('resize'));
      }

      // Mobile Menu Tabs.
      this.menu.querySelectorAll('.mobile-menu-tab').forEach(tab => tab.addEventListener('click', this.onTabClick.bind(this)));
    }

    setAnnouncementHeight() {
      const a_bar = document.querySelector('.header-announcement-bar');
      if (a_bar) {
        let h = a_bar.clientHeight;
        document.documentElement.style.setProperty('--announcement-height', h + 'px');
      }
    }
    setHeaderOffset() {
      let h = window.innerWidth > 768 ? this.header_section.getBoundingClientRect().top : 0,
        has_a = this.header_section.previousElementSibling.classList.contains('header-announcement-bar'),
        a = has_a ? parseInt(getComputedStyle(document.documentElement).getPropertyValue('--announcement-height'), 10) : 0;

      if (h >= 0 && h !== this._lastOffset) {
        this._lastOffset = h;
        document.documentElement.style.setProperty('--header-offset', h + 'px');
      }
    }
    setHeaderHeight() {
      let h = this.header_section.clientHeight;
      document.documentElement.style.setProperty('--header-height', h + 'px');
    }
    closeAll() {
      // Reset tabs to first tab
      const firstTab = this.menu.querySelector('.mobile-menu-tab');
      if (firstTab) {
        this.menu.querySelectorAll('.mobile-menu-tab').forEach(tab => {
          tab.classList.remove('active');
          tab.setAttribute('aria-selected', 'false');
        });
        this.menu.querySelectorAll('.mobile-menu-tab-panel').forEach(p => {
          p.classList.remove('active');
        });
        firstTab.classList.add('active');
        firstTab.setAttribute('aria-selected', 'true');
        const firstPanel = this.menu.querySelector('.mobile-menu-tab-panel');
        if (firstPanel) firstPanel.classList.add('active');
      }
    }
    onTabClick(event) {
      const clickedTab = event.currentTarget;
      const tabIndex = clickedTab.dataset.tabIndex;
      const tabUrl = clickedTab.dataset.tabUrl;
      const panel = this.menu.querySelector(`.mobile-menu-tab-panel[data-tab-index="${tabIndex}"]`);

      // If this tab has no sub-menu content (empty panel), navigate to the URL
      if (panel && panel.querySelector('.mobile-menu-tab-empty')) {
        window.location.href = tabUrl;
        return;
      }

      // Deactivate all tabs and panels
      this.menu.querySelectorAll('.mobile-menu-tab').forEach(tab => {
        tab.classList.remove('active');
        tab.setAttribute('aria-selected', 'false');
      });
      this.menu.querySelectorAll('.mobile-menu-tab-panel').forEach(p => {
        p.classList.remove('active');
      });

      // Activate clicked tab and its panel
      clickedTab.classList.add('active');
      clickedTab.setAttribute('aria-selected', 'true');
      if (panel) panel.classList.add('active');

      // Scroll menu to top when switching tabs
      this.menu.scrollTop = 0;
    }
    closeAnimation(detailsElement) {
      setTimeout(() => detailsElement.removeAttribute('open'), 400);
    }
  }
  customElements.define('theme-header', ThemeHeader);
}
/**
 *  @class
 *  @function FullMenu
 */
if (!customElements.get('full-menu')) {
  class FullMenu extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.header = this.closest('.header');
      this.all_subs = this.querySelectorAll('.menu-item-has-children');
      this.submenus = this.querySelectorAll('.thb-full-menu>.menu-item-has-children:not(.menu-item-has-megamenu)>.sub-menu');

      if (!this.submenus.length) {
        return;
      }
      const _this = this;
      // resize on initial load
      window.addEventListener('resize', debounce(function () {
        _this.resizeSubMenus();
      }, 100));

      window.dispatchEvent(new Event('resize'));

      document.fonts.ready.then(function () {
        _this.resizeSubMenus();
      });

      this.all_subs.forEach((subs) => {
        subs.addEventListener('mouseenter', () => {
          this.header.classList.add('menu-item-hover');
        });
        subs.addEventListener('mouseleave', () => {
          this.header.classList.remove('menu-item-hover');
        });
      });
    }
    resizeSubMenus() {
      this.submenus.forEach((submenu) => {
        let sub_submenus = submenu.querySelectorAll(':scope >.menu-item-has-children>.sub-menu');

        sub_submenus.forEach((sub_submenu) => {
          let w = sub_submenu.offsetWidth,
            l = sub_submenu.parentElement.parentElement.getBoundingClientRect().left + sub_submenu.parentElement.parentElement.clientWidth + 10,
            total = w + l;
          if (total > document.body.clientWidth) {
            sub_submenu.parentElement.classList.add('left-submenu');
          } else if (sub_submenu.parentElement.classList.contains('left-submenu')) {
            sub_submenu.parentElement.classList.remove('left-submenu');
          }
        });
      });
    }
  }
  customElements.define('full-menu', FullMenu);
}